<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="4" epub:type="part" id="part-one">
<h1 data-number="4" epub:type="part">Part One</h1>
<section class="level2" data-number="4.1" id="restoration">
<h2 data-number="4.1">Restoration</h2>
<section class="level3" data-number="4.1.1" id="section">
<h3 data-number="4.1.1">1660–1662</h3>
</section>
</section>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?213d0504